const SITE = 'DB매니저';
const ORIGIN = 'https://dbmanagement.org';
const DEFAULT_OG_IMAGE = `${ORIGIN}/assets/images/logo3.png`;

export function buildMeta({ title, description, path, noindex = false }) {
  const url = `${ORIGIN}${path}`;
  const meta = [
    { vmid: 'description', name: 'description', content: description },
    { vmid: 'og:title', property: 'og:title', content: title },
    { vmid: 'og:description', property: 'og:description', content: description },
    { vmid: 'og:url', property: 'og:url', content: url },
    { vmid: 'og:type', property: 'og:type', content: 'website' },
    { vmid: 'og:site_name', property: 'og:site_name', content: SITE },
    { vmid: 'og:locale', property: 'og:locale', content: 'ko_KR' },
    { vmid: 'og:image', property: 'og:image', content: DEFAULT_OG_IMAGE },
    { vmid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },
    { vmid: 'twitter:title', name: 'twitter:title', content: title },
    { vmid: 'twitter:description', name: 'twitter:description', content: description },
    { vmid: 'twitter:image', name: 'twitter:image', content: DEFAULT_OG_IMAGE },
  ];
  if (noindex) {
    meta.push({ vmid: 'robots', name: 'robots', content: 'noindex,follow' });
  }
  return {
    title,
    meta,
    link: [
      { vmid: 'canonical', rel: 'canonical', href: url },
    ],
  };
}
